import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import {
  APP_INITIALIZER,
  FactoryProvider,
  InjectionToken,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf
} from '@angular/core';
import { OAuthModule, OAuthModuleConfig, OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { authAppInitializerFactory } from './auth-app-initializer.factory';
import { AuthService } from './auth.service';
import { provideRouter, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './auth.guard';
import { AuthGuardWithForcedLogin } from './auth-with-forced-login.guard';
import { RoleGuard } from './role.guard';

// We need a factory since localStorage is not available at AOT build time
export function storageFactory(): OAuthStorage {
  return localStorage;
}

export const ENV_TOKEN_DESC: string = 'environment';
export const ENVIRONMENT = new InjectionToken<any>(ENV_TOKEN_DESC);

const authModuleConfigFactory = (environment: any): OAuthModuleConfig => {
  return {
    resourceServer: {
      allowedUrls: environment.allowedUrls,
      sendAccessToken: true,
    }
  };
};

const AuthModuleConfigProvider: FactoryProvider = {
  provide: OAuthModuleConfig,
  useFactory: authModuleConfigFactory,
  deps: [ENVIRONMENT]
};


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    AuthService,
    AuthGuard,
    AuthGuardWithForcedLogin,
    RoleGuard
  ],
})
export class AuthModule {
  static forRoot(routes: Routes): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        provideRouter(routes),
        provideHttpClient(),
        provideOAuthClient(),
        {
          provide: APP_INITIALIZER,
          useFactory: (authService: AuthService) => {
            return () => {
              authAppInitializerFactory(authService);
            }
          },
          multi: true,
          deps: [
            AuthService
          ]
        },
        AuthModuleConfigProvider,
        { provide: OAuthStorage, useFactory: storageFactory },
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: AuthModule) {
    if (parentModule) {
      throw new Error('AuthModule is already loaded. Import it in the AppModule only');
    }
  }
}
